import IntlMessages from "../../../../util/IntlMessages";
import React from "react";
import {HTTP_REQUEST_STATUS} from "../../../../constants/constants";
import commonStyles from "../../../../util/commonStyle";

import {

    TRANSLATION_CATEGORY_DISPLAY_NEW_EDIT_POPUP,
    TRANSLATION_CATEGORY_GET_ALL_RECORDS_SUCCESS,
    TRANSLATION_CATEGORY_HIDE_NEW_EDIT_POPUP,
    TRANSLATION_CATEGORY_NEW_EDIT_SAVE_ERROR,
    TRANSLATION_CATEGORY_NEW_EDIT_SAVE_IN_PROGRESS,
    TRANSLATION_CATEGORY_NEW_EDIT_SAVE_NONE,
    TRANSLATION_CATEGORY_NEW_EDIT_SAVE_SUCCESS,
    TRANSLATION_CATEGORY_UPDATE_STATUS_NONE,
    TRANSLATION_CATEGORY_UPDATE_STATUS_SUCCESS,
} from "../../../../constants/ActionTypes";


const translationCategoriesTblHeader = [

    {
        id: 's_no',
        align: true,
        disablePadding: false,
        label: <IntlMessages id="DIC_SETTINGS_TRANSLATION_CATEGORY_SL.NO"/>
    },

    {
        id: 'name',
        align: true,
        disablePadding: false,
        label: <IntlMessages id="DIC_SETTINGS_TRANSLATION_CATEGORY_NEW_EDIT_CATEGORY_NAME"/>
    },
    {
        id: 'category_code',
        align: false,
        disablePadding: true,
        label: <IntlMessages id="DIC_SETTINGS_TRANSLATION_CATEGORY_NEW_EDIT_CATEGORY_CODE"/>
    },
    {
        id: 'actions',
        align: false,
        disablePadding: true,
        label: <IntlMessages id="DIC_SETTINGS_TRANSLATION_CATEGORY_ACTIONS"/>
    },
];

const translationCategoriesItems = [
    {
        'key': 'name',
        'type': 'textfield',
        'style': commonStyles.popupContainer,
        'localisation': "DIC_SETTINGS_TRANSLATION_CATEGORY_NEW_EDIT_CATEGORY_NAME",
        'isMandatory': true,
    },
    {
        'key': 'category_code',
        'type': 'textfield',
        'style': commonStyles.popupContainer,
        'localisation': "DIC_SETTINGS_TRANSLATION_CATEGORY_NEW_EDIT_CATEGORY_CODE",
        'isMandatory': true,

    },
    {
        'key': 'is_active',
        'type': 'checkbox',
        'style': {
            paddingBottom: "10%",
            marginTop: "1%",
            marginLeft: "-10px"
        },
        'localisation':
            "DIC_SETTINGS_TRANSLATION_CATEGORY_NEW_EDIT_IS_ACTIVE"
    },
];

const initialData = {
    tableColumns: translationCategoriesTblHeader,
    translationCategoriesdata: [],
    loader: false,
    alertMessage: '',
    isSuccessMessage: false,
    isErrorMessage: false,
    isPopUpVisible: false,
    selectedItem: null,
    translationCategoriesSaveStatus: HTTP_REQUEST_STATUS.NOT_STARTED,
    translationCategoriesFetchStatus: HTTP_REQUEST_STATUS.NOT_STARTED,
    translationCategoriesUpdateStatusStatus: HTTP_REQUEST_STATUS.NOT_STARTED,
    translationCategoriesItems:translationCategoriesItems,
    translationCategoriesMap : [],
    translationCategoriesMapDropdown: []

};

const ReducerTranslationCategories = (state = initialData, action) => {
    switch (action.type) {
        case TRANSLATION_CATEGORY_UPDATE_STATUS_NONE:
            return {
                ...state,
                translationCategoriesUpdateStatusStatus: HTTP_REQUEST_STATUS.NOT_STARTED,
                alertMessage: ""
            };

        case TRANSLATION_CATEGORY_UPDATE_STATUS_SUCCESS:
            return {
                ...state,
                translationCategoriesUpdateStatusStatus: HTTP_REQUEST_STATUS.SUCCESS,
                alertMessage: <IntlMessages id="DIC_SETTINGS_TRANSLATION_CATEGORY_UPDATE_MESSAGE"/>
            };


        case TRANSLATION_CATEGORY_GET_ALL_RECORDS_SUCCESS:

            let translationCategoriesMap = generatetranslationCategoriesMap(action.payload);

            let dropDownValues = [];
            dropDownValues.push({
                key: -1,
                value: -1,
            });

            for ( let i = 0 ; i < translationCategoriesMap.length; i++ ) {
                dropDownValues.push(translationCategoriesMap[i]);
            }

            return {
                ...state,
                translationCategoriesFetchStatus: HTTP_REQUEST_STATUS.NOT_STARTED,
                translationCategoriesdata: action.payload,
                translationCategoriesMap: translationCategoriesMap,
                translationCategoriesMapDropdown:dropDownValues
            };

        /**** Translation Category save error ****/

        case TRANSLATION_CATEGORY_NEW_EDIT_SAVE_ERROR:
            return {
                ...state,
                alertMessage: action.payload.message,
                isErrorMessage: true,
                isSuccessMessage: false,
                isPopUpVisible: false,
                selectedItem: null,
                translationCategoriesSaveStatus: HTTP_REQUEST_STATUS.NOT_STARTED,
                loader: false
            };

        /**** Translation Category save success ****/

        case TRANSLATION_CATEGORY_NEW_EDIT_SAVE_SUCCESS:
            return {
                ...state,
                alertMessage: <IntlMessages id="DIC_SETTINGS_TRANSLATION_CATEGORY_SAVE_MESSAGE"/>,
                isErrorMessage: false,
                isSuccessMessage: true,
                isPopUpVisible: false,
                selectedItem: null,
                translationCategoriesSaveStatus: HTTP_REQUEST_STATUS.SUCCESS,
                loader: false
            };

        /**** Translation Category http status to not started ****/

        case TRANSLATION_CATEGORY_NEW_EDIT_SAVE_NONE:
            return {
                ...state,
                translationCategoriesSaveStatus: HTTP_REQUEST_STATUS.NOT_STARTED
            };

        /**** Translation Category http status to in progress ****/

        case TRANSLATION_CATEGORY_NEW_EDIT_SAVE_IN_PROGRESS:
            return {
                ...state,
                translationCategoriesSaveStatus: HTTP_REQUEST_STATUS.IN_PROGRESS
            };

        /**** to display translationCategories popup ****/

        case TRANSLATION_CATEGORY_DISPLAY_NEW_EDIT_POPUP:
            return {
                ...state,
                isPopUpVisible: true,
                selectedItem: action.payload
            };

        /**** to hide translationCategories  popup ****/

        case TRANSLATION_CATEGORY_HIDE_NEW_EDIT_POPUP:
            return {
                ...state,
                isPopUpVisible: false
            };

        default:
            return state;

    }
}


/****
 Util : for generating the category list map
 ****/
function generatetranslationCategoriesMap( data ) {
    let result = [];

    try{
        for ( let i = 0 ; i < data.length; i++ ){
            result.push({
                key: data[i]['id'],
                value: data[i]['id'],
                label: data[i]['id']
            })
        }
    } catch (ex) {
        console.error(ex);
    }
    return result;
}


export default ReducerTranslationCategories;